import { animated, useInView, useSprings } from "@react-spring/web";
import React from "react";

const CHI_TEXT_ARRAY = [
  "我們",
  "將",
  "直接",
  "從",
  "您的",
  "信用卡",
  "中",
  "扣除",
  "充電",
  "費用",
] as const;
const ENG_TEXT_ARRAY = [
  "We will debit the charging fee directly from your credit card.",
] as const;
// const ENG_TEXT_ARRAY = [
//   "We",
//   "will",
//   "debit",
//   "the",
//   "charging",
//   "fee",
//   "directly",
//   "from",
//   "your",
//   "credit",
//   "card",
// ] as const;

const ChargeText: React.FC = () => {
  const [ref, inView] = useInView({
    rootMargin: "70%",
    once: false, // Keep triggering when entering/exiting
  });

  // Create springs for Chinese text
  const chiSprings = useSprings(
    CHI_TEXT_ARRAY.length,
    CHI_TEXT_ARRAY.map(() => ({
      from: { transform: "translateY(40px)", opacity: 0 },
      to: inView
        ? { transform: "translateY(0px)", opacity: 1 }
        : { transform: "translateY(40px)", opacity: 0 },
      config: { tension: 30, friction: 20 },
      // delay: Math.random() * 400,
    }))
  );

  // Create springs for English text
  const engSprings = useSprings(
    ENG_TEXT_ARRAY.length,
    ENG_TEXT_ARRAY.map(() => ({
      from: { transform: "translateY(30px)", opacity: 0 },
      to: inView
        ? { transform: "translateY(0px)", opacity: 1 }
        : { transform: "translateY(30px)", opacity: 0 },
      config: { tension: 20, friction: 20 },
      // delay: Math.random() * 400,
    }))
  );

  return (
    <div
      ref={ref}
      className="flex flex-col justify-center items-center text-secondaryDark font-semibold mt-5 mb-5 gap-2 mx-2"
    >
      <div className="flex flex-row">
        {chiSprings.map((styles, index) => (
          <animated.span
            key={index}
            style={styles}
            className="text-sm laptop:text-2xl"
          >
            {CHI_TEXT_ARRAY[index]}
          </animated.span>
        ))}
      </div>
      <div className="flex flex-row gap-2 flex-wrap justify-center">
        {engSprings.map((styles, index) => (
          <animated.span
            key={index}
            style={styles}
            className="text-xs laptop:text-2xl"
          >
            {ENG_TEXT_ARRAY[index]}
          </animated.span>
        ))}
      </div>
    </div>
  );
};

export default ChargeText;
